'use client';

export default function SmartSuppScript() {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          var _smartsupp = _smartsupp || {};
          _smartsupp.key =  'ad2ba906d0ddfadaf0a97cd2490bf0394466c406';
          _smartsupp.offsetY = 20;
          _smartsupp.privacyNoticeEnabled = true; 
          _smartsupp.ratingEnabled = true;
_smartsupp.privacyNoticeUrl = "https://www.bitcoinfortress.app"; 
_smartsupp.privacyNoticeCheckRequired = true;
_smartsupp.backgroundColor = 'transparent';
          window.smartsupp||(function(d) {
            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
            s=d.getElementsByTagName('script')[0];c=d.createElement('script');
            c.type='text/javascript';c.charset='utf-8';c.async=true;
            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
          })(document);
          
          smartsupp('chat:widget', {
            buttonStyle: 'background: none; border: none; width: 60px; height: 60px;',
          });
        `,
      }}
    />
  );
}
